<template>
  <v-list-item @click="click">
    <v-list-item-action>
      <v-checkbox :class="checkboxClass" color="primary" :input-value="value" :disabled="checkboxDisabled"></v-checkbox>
    </v-list-item-action>
    <v-list-item-content class="align-start">
      <div v-html="texte"></div>
    </v-list-item-content>
  </v-list-item>
</template>
<script>

export default {
  data() {
    return {
      checkboxClass: "",
      checkboxDisabled: false,
    }
  },
  props: {
    texte: String,
    value: Boolean,
    propertyName: String,
    disabled: Boolean,
    radioMode: Boolean,
  },
  mounted(){
    if(this.disabled) {
      this.checkboxDisabled = true;
    }

    if(this.radioMode) {
      this.checkboxClass = "classic-disabled-checkbox";
      this.checkboxDisabled = true;
    }
  },  
  methods: {
    click() {
      if (this.disabled) return

      this.update(!this.value)
    },
    update(event) {
      this.$emit("updateChoix", { field: this.propertyName, choix: event })
    },
  },
}
</script>

<style>
/*Permet d'appliquer un style classique pour les v-checkbox désactivées afin de simuler des radio-inputs custom*/
.classic-disabled-checkbox i.v-icon {
  color: var(--v-primary-base) !important;
}
</style>
